import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useState
} from 'react';
import { createPortal } from 'react-dom';

import { ReactRenderer } from '@tiptap/react';

import axios from 'common/utils/axios';

import { ListAvatar } from 'components/molecules';

import { MentionPopup, MentionWrapper } from './rich-editor-style';

const search = (value, options = {}) => {
  const params = { ...options, name: value };
  return axios.get('/api/v1/employees/search', { params });
};

const MentionList = forwardRef((props, ref) => {
  const { query, command, clientRect } = props;
  const [selectedIndex, setSelectedIndex] = useState(0);

  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (query.length) {
      setLoading(true);
      search(query)
        .then(({ data }) => setItems(data))
        .finally(setLoading);
    }
  }, [query]);

  const selectItem = index => {
    const item = items[index];

    if (item) {
      command({ id: item.id, label: item.full_name });
    }
  };

  useEffect(() => setSelectedIndex(0), [items]);

  const visibleItems = Math.min(items.length, 5);

  useImperativeHandle(ref, () => ({
    onKeyDown: ({ event }) => {
      if (event.key === 'ArrowUp') {
        setSelectedIndex((selectedIndex + visibleItems - 1) % visibleItems);
        return true;
      }

      if (['ArrowDown', 'Tab'].includes(event.key)) {
        setSelectedIndex((selectedIndex + 1) % visibleItems);
        return true;
      }

      if (event.key === 'Enter') {
        selectItem(selectedIndex);
        return true;
      }

      return false;
    }
  }));

  const { bottom, left } = clientRect();
  const position = { top: bottom, left };

  const handleClick = item => event => {
    event.preventDefault();
    command({ id: item.id, label: item.full_name });
  };

  if (!query.length) return null;

  return createPortal(
    <MentionPopup small position={position}>
      {items.length ? (
        items.slice(0, 5).map((item, index) => (
          <MentionWrapper
            key={item.id}
            tabIndex='0'
            active={selectedIndex === index}
            onMouseDown={handleClick(item)}
            onMouseEnter={() => setSelectedIndex(index)}
          >
            <ListAvatar list noLink {...item} name={item.full_name} />
          </MentionWrapper>
        ))
      ) : (
        <div className='item'>{loading ? 'Loading...' : 'No results'}</div>
      )}
    </MentionPopup>,
    document.body
  );
});

const suggestion = {
  char: '@',

  render: () => {
    let component;
    // let popup;

    return {
      onStart: props => {
        component = new ReactRenderer(MentionList, {
          props,
          editor: props.editor
        });

        // if (!props.clientRect) {
        //   return;
        // }

        // popup = new ReactRenderer(ActionDropdown, {
        //   props,
        //   editor: props.editor
        // });
      },

      onUpdate(props) {
        component.updateProps(props);

        // if (!props.clientRect) {
        //   return;
        // }

        // popup[0].setProps({
        //   getReferenceClientRect: props.clientRect
        // });
      },

      onKeyDown(props) {
        if (props.event.key === 'Escape') {
          // popup[0].hide();

          return true;
        }

        return component.ref?.onKeyDown(props);
      },

      onExit() {
        // popup[0].destroy();
        component.destroy();
      }
    };
  }
};

export default suggestion;
